import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      const language = localStorage.getItem('language') || 'en';
      const isArabic = language === 'ar';

      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
          fontFamily: isArabic ? 'Tajawal, Arial, sans-serif' : 'Roboto, Arial, sans-serif',
          direction: isArabic ? 'rtl' : 'ltr',
          padding: '20px',
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '40px',
            maxWidth: '500px',
            width: '100%',
            textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          }}>
            {/* أيقونة تحذير */}
            <div style={{ fontSize: '64px', marginBottom: '16px' }}>⚠️</div>
            
            <h2 style={{ color: '#d32f2f', marginBottom: '12px', fontSize: '22px' }}>
              {isArabic ? 'حدث خطأ غير متوقع' : 'Something went wrong'}
            </h2>
            
            <p style={{ color: '#666', marginBottom: '24px', fontSize: '15px', lineHeight: '1.6' }}>
              {isArabic 
                ? 'حدث خطأ أثناء تحميل الصفحة. يرجى المحاولة مرة أخرى أو العودة للصفحة الرئيسية.'
                : 'An error occurred while loading this page. Please try again or return to the dashboard.'}
            </p>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={this.handleReset}
                style={{
                  padding: '10px 24px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  transition: 'background-color 0.2s',
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1565c0')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1976d2')}
              >
                {isArabic ? 'إعادة المحاولة' : 'Try Again'}
              </button>
              
              <button
                onClick={this.handleGoHome}
                style={{
                  padding: '10px 24px',
                  backgroundColor: '#fff',
                  color: '#1976d2',
                  border: '2px solid #1976d2',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  transition: 'background-color 0.2s',
                }}
                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
              >
                {isArabic ? 'الصفحة الرئيسية' : 'Go to Dashboard'}
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;